export default {
    fref: '',
    fmod: '',
    fcol: '',
    fdate_cdemin: '',
    fdate_cdemax: '',
    fstatut: '100',
    fncde: '',
    launch_research: false,
    reset_order_list: false,

    pnocde: '', 

    detail_fref: '',
    detail_fmod: '',
    detail_fcol: '',
    detail_ftail: '',
    launch_detail_research: false,
};